export namespace CreateFOPNS {
  export interface CreateFOPRequest {
    transactionContext: TransactionContext;
    fopGroups: FopGroup[];
  }

  export interface TransactionContext {
    code: string;
    issueIndicator: string;
  }

  export interface FopGroup {
    fopReference: FopReference;
    pnrElementAssociation: PnrElementAssociation[];
    mopDescriptions: MopDescription[];
  }

  export interface FopReference {
    qualifier: string;
    number: number;
  }

  export interface PnrElementAssociation {
    type: string;
    value: number;
  }

  export interface FopDetail {
    fopCode?: string;
    fopStatus: string;
  }

  export interface GroupUsage {
    attributeType: string;
  }

  export interface PaymentData {
    merchantInformation: MerchantInformation;
    paymentIds: PaymentId[];
  }

  export interface MerchantInformation {
    companyCode: string;
  }

  export interface PaymentId {
    referenceType: string;
    uniqueReference: string;
  }

  export interface MopInformation {
    formOfPaymentType: string;
    creditCardData: CreditCardData;
  }

  export interface CreditCardData {
    vendorCode: string;
    cardNumber: string;
    expiryDate: string;
    ccHolderName: string;
  }

  export interface CreateFOPResponse {
    fopDescriptions: FopDescription[];
    transmissionError: TransmissionError;
  }

  export interface FopDescription {
    fopReference: FopReference;
    pnrElementAssociations: PnrElementAssociation[];
    passengerAssociations: PassengerAssociation[];
    mopDescriptions: MopDescription[];
    fpElementError: FpElementError;
  }

  export interface FopReference {
    qualifier: string;
    number: number;
  }

  export interface PnrElementAssociation {
    type: string;
    value: number;
  }

  export interface PassengerAssociation {
    type: string;
    value: number;
  }

  export interface MopDescription {
    fopSequenceNumber: number;
    mopDetails: MopDetails;
    paymentModule?: PaymentModule;
  }

  export interface MopDetails {
    fopDetails: FopDetail[];
    oldFopFreeflow?: OldFopFreeflow;
    pnrSupplementaryData?: PnrSupplementaryDaum[];
  }

  export interface OldFopFreeflow {
    freeText: string;
    textSubjectQualifier?: string;
    source?: string;
    encoding?: string;
  }

  export interface PnrSupplementaryDaum {
    criteriaDetails: CriteriaDetail[];
    criteriaSetType: string;
  }

  export interface CriteriaDetail {
    attributeType: string;
    attributeDescription: string;
  }

  export interface PaymentModule {
    groupUsage: GroupUsage;
    paymentData: PaymentData;
    mopInformation: MopInformation;
    mopDetailedData?: MopDetailedData;
  }

  export interface GroupUsage {
    attributeType: string;
    attributeDescription?: string;
  }

  export interface PaymentData {
    merchantInformation: MerchantInformation;
    monetaryInformation?: MonetaryInformation[];
    paymentIds: PaymentId[];
  }

  export interface MerchantInformation {
    companyCode: string;
    companyNumericCode?: string;
  }

  export interface MonetaryInformation {
    monetaryDetails: MonetaryDetails;
    otherMonetaryDetails: OtherMonetaryDetail[];
  }

  export interface MonetaryDetails {
    typeQualifier: string;
    amount: number;
    currency: string;
  }

  export interface OtherMonetaryDetail {
    typeQualifier: string;
    amount: number;
    currency: string;
  }

  export interface PaymentId {
    referenceType: string;
    uniqueReference: string;
  }

  export interface MopInformation {
    formOfPaymentType: string;
    creditCardData: CreditCardData;
  }

  export interface CreditCardData {
    vendorCode: string;
    cardNumber: string;
    securityId?: string;
    expiryDate: string;
    ccHolderName: string;
  }

  export interface MopDetailedData {
    formOfPaymentType: string;
    creditCardDetailedData: CreditCardDetailedData;
  }

  export interface CreditCardDetailedData {
    approvalCode: string;
    sourceOfApproval: string;
    cardSupplementaryDetails: CardSupplementaryDetail[];
    authorisationSupplementaryData: AuthorisationSupplementaryData;
  }

  export interface CardSupplementaryDetail {
    criteriaSetType: string;
    attributeType: string;
    attributeDescription: string;
  }

  export interface AuthorisationSupplementaryData {
    retrievalReferenceNumber: string;
    authorResponseCode: string;
    terminalType: string;
  }

  export interface FpElementError {
    errorCode: string;
    errorCategory: string;
    textSubjectQualifier: string;
    source: string;
    encoding: string;
    freeTextList: string[];
  }

  export interface TransmissionError {
    errorCode: string;
    textSubjectQualifier: string;
    source: string;
    encoding: string;
    freetext: string;
  }

  export const enum FOPType {
    'CreateTST' = 'CreateTST',
    'CreateTSM' = 'CreateTSM',
  }

  export const enum FopStatus {
    OLD = 'O',
    NEW = 'N',
  }

  export const enum FOP {
    'TST' = 'TST',
    'TSM' = 'TSM',
  }
}
